<div class="your-list-claim">
  <header>
    <app-input-dropdown
      id="tag-filter"
      [title]="'Select an option' | translate"
      [matMenuTriggerFor]="menu"
    >
      <mat-menu #menu="matMenu" classList="drop-btn-menu">
        <button
          mat-menu-item=""
          [id]="itemMenu.label"
          (click)="onClickItemMenu(itemMenu.value)"
          *ngFor="let itemMenu of itemsMenu"
          id=""
        >
          {{ itemMenu.label | translate }}
        </button>
      </mat-menu>
    </app-input-dropdown>
  </header>

  <section *ngIf="claimsToShow">
    <ng-container *ngFor="let claim of claimsToShow">
      <app-block-claim [claim]="claim"></app-block-claim>
    </ng-container>
  </section>
</div>
